/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ type: NonNullable<unknown> }} Chat_Save_To_Space_TypeInputs */



/**
* | output |
* | --- |
* | "Type: {type}" |
*
* @param {Chat_Save_To_Space_TypeInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const chat_save_to_space_type = /** @type {((inputs: Chat_Save_To_Space_TypeInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Chat_Save_To_Space_TypeInputs, { locale?: "en" | "de" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ (`Typ: ${i?.type}`)
	return /** @type {LocalizedString} */ (`Type: ${i?.type}`)
});